import styled from 'styled-components';

import { Icon as UnstyledIcon } from 'features/common/components/Icon';

export const Pre = styled.pre`
	background-color: ${({ theme }) => theme.colors.black};
	border-radius: 4px;
	padding: 10px;
`;

export const Anchor = styled.a`
	all: unset;
	width: fit-content;
	height: 40px;
	display: flex;
	cursor: pointer;
	border-radius: 21px;
	align-items: center;
	justify-content: center;
	font-family: ${({ theme }) => theme.fonts.primary};
	background: ${({ theme }) => theme.colors.greenGradient3};
	box-shadow: ${({ theme }) => theme.shadows.buttonWithIconShadow};
	gap: 10px;
	padding: 0 16px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-family: ${({ theme }) => theme.fonts.primary};
		font-size: 14px;
		font-weight: 600;
		height: 35px;
		line-height: 21px;
		letter-spacing: 0em;
		text-align: center;

		img {
			height: 18px;
			width: 18px;
		}
	}
`;

export const Icon = styled(UnstyledIcon)`
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		height: 18px;
		width: 18px;
	}
`;
